

export default function MediaPreview({

    media

}) {

    if (!media) {

        return null;

    }
const icon =

media.isPdf

? "📕"

: media.mime_type?.includes("word")

? "📘"

: media.mime_type?.includes("excel")

? "📗"

: media.mime_type?.includes("powerpoint")

? "📙"

: media.mime_type?.includes("zip")

? "🗜️"

: media.mime_type?.includes("text")

? "📄"

: "📁";
    return (

        <div className="media-preview">

            {

                media.isImage

                ?

                <img

                    src={media.previewUrl}

                    alt={media.original_name}

                />

                :

                media.isVideo

                ?

                <video

                    controls

                    preload="metadata"

                >

                    <source

                        src={media.previewUrl}

                        type={media.mime_type}

                    />

                </video>

                :

                media.isAudio

                ?

                <audio controls>

                    <source

                        src={media.previewUrl}

                        type={media.mime_type}

                    />

                </audio>

                :

                media.isPdf

                ?

                <iframe

                    src={media.previewUrl}

                    title={media.original_name}

                />

                :

                <div className="preview-placeholder">

                   <div className="preview-icon">

    {icon}

</div>

                    <div>

                        {media.extension?.toUpperCase()}

                    </div>

                </div>

            }

<style>{`

.media-preview{

    width:100%;

    min-height:240px;

    border:1px solid #E5E7EB;

    border-radius:14px;

    overflow:hidden;

    background:#F9FAFB;

    display:flex;

    justify-content:center;

    align-items:center;

}

.media-preview img{

    width:100%;

    height:auto;

    object-fit:contain;

    display:block;

}

.media-preview video{

    width:100%;

    max-height:340px;

    background:#000;

}

.media-preview audio{

    width:90%;

}

.media-preview iframe{

    width:100%;

    height:420px;

    border:none;

}

.preview-placeholder{

    display:flex;

    flex-direction:column;

    align-items:center;

    gap:14px;

    color:#6B7280;

    padding:40px;

}

.preview-icon{

    font-size:72px;

}

`}</style>

        </div>

    );

}